export default [
  {
    header: 'Destinatari',
    resource: 'destinatari',
    action: 'read',
  },
]
